<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"></v-progress-circular>
  <div v-else class="system-status">
    <h1 class="text-center">System Status</h1>
    <div class="label-date">
      <div>Data from API as of {{ currentDate }}</div>
      <button class="btn btn-primary" @click="getList">Refresh</button>
    </div>
    <div class="table-list">
      <b-table
        class="table table-responsive table-bordered mt-5"
        hover
        responsive
        :fields="fields"
        :items="systemStatusResults"
        :per-page="perPage">
        <template #cell(responseMessage)="data">
          <div style="max-width: 350px">
            {{ data.item.responseMessage }}
          </div>
        </template>
      </b-table>
      <b-pagination
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
        class="my-0"
        aria-controls="my-table" />
    </div>
  </div>
</template>
<script>
import SystemService from "@/services/api/system.service";
import moment from "moment";
export default {
  data() {
    return {
      isLoading: false,
      systemStatusResults: [],
      totalItems: 0,
      currentPage: 1,
      perPage: 10,
      fields: [
        {
          key: "testName",
          label: "Name",
          sortable: true,
        },
        {
          key: "testResult",
          label: "Result",
          sortable: true,
        },
        {
          key: "responseCode",
          label: "Response Code",
          sortable: true,
        },
        {
          key: "responseMessage",
          label: "Response message",
          sortable: true,
        },
      ],
      currentDate: moment().format("YYYY-MM-DD HH:mm:ss"),
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      this.isLoading = true;
      await SystemService.getListSystemStatus()
        .then((res) => {
          const data = res.data;
          this.isLoading = false;
          this.currentDate = moment().format("YYYY-MM-DD HH:mm:ss");
          this.systemStatusResults = data.systemStatusResults;
        })
        .catch((err) => {
          console.log("Error: ", err.response);
          this.isLoading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 400px) {
  .centered {
    left: 44% !important;
  }
}
.system-status {
  position: relative;
  top: 20%;
  .table-list,
  .label-date {
    margin: 2rem 0;
  }
  .label-date {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
